import { denormalize } from "normalizr";

import { getEntities } from "./entities";
import { seoSchema } from "../schemas";

export const DEFAULT_MODIFICATION = "form";

export function getSeo(state, id) {
  return denormalize(id, seoSchema, getEntities(state));
}